import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import NonSearchableSelectMenu from "@/app/components/ui/SelectMenus/NonSearchableSelectMenu";
import { useConfigurationClincCopyImagesListAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationClinicCopyImagesAPI";
import { useOrderManagementClinicListAPI } from "@/app/hooks/api_hooks/orders/useOrderClinicListAPI";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const CopyImageContent = ({ setId }) => {
  let imagesFetched = false;
  const formHook = useForm();
  const { getRouteKey } = useRouter();
  const clinicListAPI = useOrderManagementClinicListAPI();
  const routeIdOrder = getRouteKey("ORDER_MANAGEMENT", "id");
  const { routeState: routeStateConfig } = useRouteInfo(routeIdOrder);

  useEffect(() => {
    if (!imagesFetched) {
      clinicListAPI();
      imagesFetched = true;
    }
  }, []);

  const clinicsOrg = routeStateConfig?.state?.clinicList?.results;
  const clinicsOrgItem = useSelectMenuReducer(clinicsOrg, "name", "id");

  return (
    <div className="p-4 bg-white rounded-[20px] flex-col justify-start items-end gap-6 inline-flex">
      <div className="justify-start items-center gap-16 inline-flex">
        <div className="p-2.5 justify-start items-center gap-2.5 flex">
          <div className="text-black text-xs font-normal">Name</div>
        </div>
        <div className="h-9 justify-center items-center gap-2.5 flex">
          <div className="h-9 w-[300px] mt-2">
            <NonSearchableSelectMenu
              errorMessages={[]}
              onSelectItem={(item) => {
                if (item) {
                  formHook.setValue("clinic", item.id);
                  setId(item.id);
                }
              }}
              fieldError={formHook.formState.errors.clinic}
              register={formHook.register("clinic", { required: true })}
              selectItems={clinicsOrgItem}
              placeholder="Select Clinic"
              showTooltips={false}
              showTypedErrors={false}
              showDropdownIcon={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
const CopyImageModal = () => {
  let clinicsFeched = false;
  const [id, setId] = useState();
  const fetchClinicCopyImages = useConfigurationClincCopyImagesListAPI();

  return (
    <ModalPrompt
      modalId="COPY_IMAGE_MODAL"
      showIcon={false}
      contentOverflow={true}
      titleIcon=""
      dialogClassName="sm:my-8 sm:w-full sm:max-w-2xl sm:p-6"
      button={{
        primaryButtonText: "Save",
        secondaryButtonText: "Cancel",
        primaryButtonClassname:
          "px-6 cursor-pointer py-[9px] bg-sky-900 hover:bg-sky-900 rounded-md border border-slate-400 border-opacity-20 justify-center items-center gap-2 flex",
        primaryCallback: () => {
          if (!clinicsFeched) {
            fetchClinicCopyImages(id);
            clinicsFeched = true;
          }
        },
        shouldHideOnClick: true,
      }}
      title="Copy From Another Clinic"
      content={<CopyImageContent setId={setId} />}
    />
  );
};

export default CopyImageModal;
